import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SelectOptionRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SelectOptionResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const selectOption = (request: SelectOptionRequest, options?: CashRequestOptions) =>
  post<SelectOptionRequest, SelectOptionResponse>('/2.0/cash/select-option', request, {
    ...options,
    rejectOnError: true,
  })
